// JsFromRoutes CacheKey b996eab950efbffe063ff407e8e8c91f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/god-mode/ip_blocks'),
  create: /* #__PURE__ */ definePathHelper('post', '/god-mode/ip_blocks'),
  update: /* #__PURE__ */ definePathHelper('patch', '/god-mode/ip_blocks/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/god-mode/ip_blocks/:id'),
}
